module.exports = __webpack_public_path__ + "img/cavin-corporate.d3848c25.png";